'use strict';

module.exports = require('./packages/dd-trace/browser');